module.exports = __webpack_public_path__ + "static/media/less-than-equal.82de5ea8.svg";